import { required, number } from 'react-admin';

const ValidateBidFloor = [required(), number()];

export default ValidateBidFloor;



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/Pmp/Helpers/ValidateBidFloor.tsx